// extracted by mini-css-extract-plugin
export default {"card_config":"ProjectTemplate_card_config__4fdzi","selected_card":"ProjectTemplate_selected_card__0LscC","templateImage":"ProjectTemplate_templateImage__Je6xt"};